import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToast } from 'hooks/ui';
import { commentKeys } from './queryKeys';
import { useApplicationStore } from 'store/application';
import { updateBroadcastComment } from 'api/comment.service';
import { TComment } from 'models/task-comment.model';

export const useBroadcastCommentUpdateQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { isPending, mutate, data } = useMutation({
    mutationFn: (info: { entityId: string; comment: TComment }) => {
      setLoading();

      return updateBroadcastComment(info.comment);
    },
    onSuccess: () => {
      toast.success('Comment has been updated successfully');
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: (_comment, _error, info) => {
      removeLoading();
      queryClient.invalidateQueries({
        queryKey: commentKeys.broadcast(info.entityId),
      });
    },
  });

  return { isLoading: isPending, mutate, data };
};
